import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { LEAD_SCORE_TYPE_CONFIG } from "app/pages/sales-intelligence/modules/lead-scoring-agent/configuration/score-type";
import type { LeadPriorityScore } from "app/pages/sales-intelligence/modules/lists/types/columns";

import { StyledDropZoneCircle, StyledScoringRuleDropZone } from "./styles";

type Props = {
    priority: LeadPriorityScore;
};

export const ScoringRuleDropZone = ({ priority }: Props) => {
    const { translate } = useTranslate();
    const priorityLabel = translate(LEAD_SCORE_TYPE_CONFIG[priority].labelKey);

    return (
        <StyledScoringRuleDropZone data-automation={`scoring-board.drop-zone.${priority}`}>
            <Stack
                gap="12px"
                alignItems="center"
            >
                <StyledDropZoneCircle>
                    <SWReactIcons
                        iconName="plus"
                        size="sm"
                    />
                </StyledDropZoneCircle>
                <Text
                    fontVariant="body2"
                    textAlign="center"
                >
                    {translate("si.pages.score_settings.board.drag_drop.move_to", { type: priorityLabel })}
                </Text>
            </Stack>
        </StyledScoringRuleDropZone>
    );
};
